import { Component } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
	selector: 'app-dashboard-chart-pie',
	standalone: false,
	templateUrl: './dashboard-chart-pie.component.html',
	styleUrl: './dashboard-chart-pie.component.scss'
})
export class DashboardChartPieComponent {
	options: EChartsOption = {
		tooltip: { trigger: 'item' },
		legend: { orient: 'vertical', left: 'left' },
		series: [{
			type: 'pie',
			radius: '60%',
			data: [
				{ value: 335, name: 'North' },
				{ value: 310, name: 'South' },
				{ value: 234, name: 'East' },
				{ value: 135, name: 'West' }
			]
		}]
	};
}
